<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Business Unit Email Contact Id"
          [matTooltipDisabled]="disabledTooltip(this.businessUnitEmailContactId)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.businessUnitEmailContactId">Business Unit Email Contact
            Id</mat-label>
          <input matInput formControlName="businessUnitEmailContactId" id="businessUnitEmailContactId"
            (ngModelChange)="businessUnitEmailContactIdChanging($event)" [(ngModel)]="item.businessUnitEmailContactId"
            (ngModelChange)="businessUnitEmailContactIdChanged($event)" #businessUnitEmailContactId type="number"
            placeholder="Business Unit Email Contact Id">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="item.businessUnit" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnitDisplay(businessUnit)}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Addr Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.addrType)" class="crud-item-input-wider">
          <mat-label i18n="@@type.BusinessUnitEmailContact.addrType">Addr Type</mat-label>
          <mat-select formControlName="addrType" id="addrType" (ngModelChange)="addrTypeChanging($event)"
            [(ngModel)]="item.addrType" (ngModelChange)="addrTypeChanged($event)" #addrType placeholder="Addr Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let addrType of addrTypeSelectionList" [value]="addrType.code">
              {{addrType.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitEmailContact.description">Description</mat-label>
          <input matInput formControlName="description" id="description" (ngModelChange)="descriptionChanging($event)"
            [(ngModel)]="item.description" (ngModelChange)="descriptionChanged($event)" #description maxlength="255"
            placeholder="Description">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Email" [matTooltipDisabled]="disabledTooltip(this.email)"
          class="crud-item-input-wide">
          <mat-label i18n="@@type.BusinessUnitEmailContact.email">Email</mat-label>
          <input matInput formControlName="email" id="email" (ngModelChange)="emailChanging($event)"
            [(ngModel)]="item.email" (ngModelChange)="emailChanged($event)" #email maxlength="255" placeholder="Email">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy" (ngModelChange)="createdByChanging($event)"
            [(ngModel)]="item.createdBy" (ngModelChange)="createdByChanged($event)" #createdBy maxlength="255"
            placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate" (ngModelChange)="createdDateChanging($event)"
            [(ngModel)]="item.createdDate" (ngModelChange)="createdDateChanged($event)" #createdDate
            [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy" (ngModelChange)="updatedByChanging($event)"
            [(ngModel)]="item.updatedBy" (ngModelChange)="updatedByChanged($event)" #updatedBy maxlength="255"
            placeholder="Updated By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.BusinessUnitEmailContact.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate" (ngModelChange)="updatedDateChanging($event)"
            [(ngModel)]="item.updatedDate" (ngModelChange)="updatedDateChanged($event)" #updatedDate
            [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

  </form>
</div>